import React, { useState } from 'react'
import { Question_Form } from '../../components/Questions_form'
import { FormHeader } from '../../components/FormHeader'
export const Form = () => {
    return (
        <>
            <Question_Form />
        </>
    )
}